import React from "react";
import { Col } from "react-bootstrap";
import { useDroppable } from "@dnd-kit/core";

import KanbanCard from "./KanbanCard";
import withRouter from "../../util/WithRouter";

const COLUMN_COLORS = [
  "#3B82F6", // Blue
  "#10B981", // Emerald
  "#F59E0B", // Amber
  "#EF4444", // Red
  "#8B5CF6", // Violet
  "#EC4899", // Pink
  "#06B6D4", // Cyan
  "#6366F1", // Indigo
  "#84CC16", // Lime
  "#64748B", // Slate
];

class KanbanColumn extends React.PureComponent {
  render() {
    const {
      columnKey,
      column,
      totalCount,
      loading,
      onAnchorRef,
      onContainerRef,
      index
    } = this.props;

    const headerColor = COLUMN_COLORS[index % COLUMN_COLORS.length];

    return (
      <Col sm={6} lg={4} xl={3} className="p-0">
        <div
          className="kanban-column"
          ref={onContainerRef}
        >
          <div 
            className="column-header" 
            style={{ 
              backgroundColor: headerColor,
              color: "#fff",
              padding: "10px 15px",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            <h3 className="column-title" style={{ color: "#fff", margin: 0 }}>
              {column.label}
            </h3>
            <span 
              className="column-badge" 
              style={{ 
                backgroundColor: "rgba(255,255,255,0.2)",
                color: "#fff" 
              }}
            >
              {totalCount}
            </span>
          </div>
          {/* I want a sleek scroll bar of color headerColor */}
            <DroppableColumn columnKey={columnKey} scrollColor={headerColor}>
              <div className="column-cards">
                {column.items.length === 0 && !loading ? (
                  <div className="empty-column">
                    <p>No Record</p>
                  </div>
                ) : (
                  column.items.map(lead => (
                    <KanbanCard key={`${columnKey}-${lead.id}`} lead={lead} model={this.props.model} headerColor={headerColor} columnKey={columnKey} />
                  ))
                )}

                <div
                  ref={onAnchorRef}
                  style={{ height: 1 }}
                  className={`d-flex justify-content-center ${loading ? "pb-3": ""}`}
                >
                  {loading && 
                    <div className="spinner-border spinner-border-sm" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  }
                </div>
              </div>
            </DroppableColumn>
        </div>
      </Col>
    );
  }
}

const DroppableColumn = ({ columnKey, scrollColor, children }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: `column-${columnKey}`,
    data: { columnKey }
  });

  return <div ref={setNodeRef} className={`kanban-column-drop ${isOver ? "drag-over" : ""}`} style={{ '--sb-color': scrollColor }}>
    {children}
  </div>
}

export default withRouter(KanbanColumn);